export default function Footer() {
    return (
        <footer
            data-testid="footer"
            className="bg-cream border-t border-cream py-10"
        >
            <div className="max-w-7xl mx-auto px-5 sm:px-8 lg:px-12 flex flex-col sm:flex-row items-center justify-between gap-4">
                <p className="font-serif text-emerald-brand text-lg">
                    Inglês Destravado em 30 Dias
                </p>
                <p className="text-sm text-emerald-light/70 text-center sm:text-right">
                    © {new Date().getFullYear()} · Todos os direitos
                    reservados.
                    <br className="sm:hidden" /> Este produto não garante
                    resultados — depende da sua aplicação.
                </p>
            </div>
        </footer>
    );
}
